import challengeList from './ChallengeListPage/reducer';
import challenge from './ChallengePage/reducer';
import profileReducer from './ProfilePage/reducer';
import achievement from './AchievementsPage/reducer';
import multichoiceTestPage from './MultichoiceTestPage/reducer';
import candidateFeedback from './CandidateFeedbackPage/reducer';
import statistics from './StatisticsPage/reducer';
import payments from './PaymentsPage/reducer';
import customTests from './CustomTestsPage/reducer';
import comments from '../components/comments/reducer';
import superAdmin from '../containers/SuperAdminPage/reducer';
import candidateTickets from './CandidateTicketsPage/reducer';
import settings from './SettingsPage/reducer';
import sendTest from './SendTestPage/reducer';
import report from './ReportPage/reducer';
import hackathonMatches from './HackathonMatches/reducer';
import xp from './XPPage/reducer';
import questionFeedback from './QuestionFeedbackPage/reducer';
import unsubscribe from './UnsubscribePage/reducer';
import CMSAllChallengesReducer from '../screens/cmsAllChallenges/reducer';
import CMSAllContestsReducer from '../screens/cmsAllContests/reducer';
import CMSCandidateInfoReducer from '../screens/cmsCandidateInfo/reducer';

const userReducers = {
  challengeList,
  challenge,
  profile: profileReducer('ME'),
  userProfile: profileReducer('OTHER'),
  achievement,
  multichoiceTestPage,
  candidateFeedback,
  statistics,
  payments,
  customTests,
  comments,
  superAdmin,
  candidateTickets,
  settings,
  sendTest,
  report,
  hackathonMatches,
  xp,
  questionFeedback,
  unsubscribe,
  CMSAllChallengesReducer,
  CMSAllContestsReducer,
  CMSCandidateInfoReducer,
};

export default userReducers;
